


































































































































import Vue from "vue";
import Component from "vue-class-component";
import ApiFactory from "../../api/ApiFactory";
import {
  CreateLiabilityCardCommand,
  FactFindLiabilityCardDto,
  OwnerDto,
  YesNoDefaultDto,
  ProductProviderDto,
  UpdateLiabilityCardCommand,
  ClientSelector
} from "@/api/ClientPortalApiClient";
import CbxOwner from "@/views/lookups/CbxOwner.vue";
import CbxProductProvider from "@/views/lookups/CbxProductProvider.vue";
import CbxLiabilityTypes from "@/views/lookups/CbxLiabilityTypes.vue";
import CbxYesNoDefault from "@/views/lookups/CbxYesNoDefault.vue";
import AlertService from "../../services/alert.service";
import { LoadingSpinnerService } from "@/store";

@Component({
  components: {
    CbxOwner,
    CbxYesNoDefault,
    CbxProductProvider,
    CbxLiabilityTypes
  }
})
export default class FactFindLiabilityCard extends Vue {
  private alertService = new AlertService();
  private contactId: number = 0;
  private cards: FactFindLiabilityCardDto[] = [];
  private emptyCard = new FactFindLiabilityCardDto();
  private displayModel = new FactFindLiabilityCardDto();
  private selectCard = new FactFindLiabilityCardDto();
  private formEnabled: boolean = false;
  private mode: string = "default";
  private clientNames: OwnerDto[] = [];
  private modelSig = "";

  async created() {
    this.contactId = parseInt(this.$route.params.contactId);
    await this.loadCards(true);
    await this.getClientSelectorNames();
  }

  $refs!: {
    owner: CbxOwner;
    productProvider: CbxProductProvider;
    mainForm: HTMLFormElement;
  };

  private async getClientSelectorNames() {
    const api = ApiFactory.CreateDataClient();
    const data = await api.owner_Index(this.contactId);
    this.clientNames = data || [];
  }

  private cardDisplayName(card: FactFindLiabilityCardDto): string {
    const owner = this.clientNames.find(x => x.id === card.cardOwner);
    return (
      (owner ? owner.name : "") +
      " - " +
      (card.cardCompany ? card.cardCompany.name : "")
    );
  }
  public saveCard(e: Event) {
    e.preventDefault();
    if (this.mode === "update") {
      this.update();
    } else if (this.mode === "create") {
      this.createNew();
    }
  }

  private async createNew(): Promise<boolean> {
    LoadingSpinnerService.Show("Saving new Card...");
    const api = ApiFactory.CreateDataClient();
    let cmd = new CreateLiabilityCardCommand();

    cmd.contactId = this.contactId;
    cmd.cardOwner = this.displayModel.cardOwner;
    cmd.currentBalance = this.displayModel.currentBalance;
    cmd.monthlyRepayment = this.displayModel.monthlyRepayment;
    cmd.annualPercentageRate = this.displayModel.annualPercentageRate;

    if (this.displayModel.cardCompany) {
      cmd.cardCompnanyId = this.displayModel.cardCompany.id;
    }

    try {
      const result = await api.factFindLiabilityCard_IndexPOST(cmd);
      this.displayModel.id = result;
      await this.loadCards();
      this.displayModel =
        this.cards.find(x => x.id === result) || this.displayModel;
      this.mode = "update";
      this.modelSig = this.displayModel.toJSON();
      LoadingSpinnerService.Success("Card saved successfully");
      return true;
    } catch (e) {
      LoadingSpinnerService.Failure("Could not save Card. Please try again.");
    }

    return false;
  }

  private async update(): Promise<boolean> {
    LoadingSpinnerService.Show("Updating Card...");
    const api = ApiFactory.CreateDataClient();
    let cmd = new UpdateLiabilityCardCommand();

    cmd.contactId = this.contactId;
    cmd.id = this.displayModel.id;
    cmd.cardOwner = this.displayModel.cardOwner;
    cmd.currentBalance = this.displayModel.currentBalance;
    cmd.monthlyRepayment = this.displayModel.monthlyRepayment;
    cmd.annualPercentageRate = this.displayModel.annualPercentageRate;
    cmd.percentageRepaidMonthly = this.displayModel.percentageRepaidMonthly;

    if (this.displayModel.cardCompany) {
      cmd.cardCompnanyId = this.displayModel.cardCompany.id;
    }

    try {
      await api.factFindLiabilityCard_IndexPUT(cmd);
      this.modelSig = JSON.stringify(this.displayModel.toJSON()).toString();
      LoadingSpinnerService.Success("Card updated successfully");
      return true;
    } catch (e) {
      LoadingSpinnerService.Failure("Could not save Card. Please try again.");
    }

    return false;
  }

  private async loadCards(showLoader: boolean | undefined = undefined) {
    if (showLoader) LoadingSpinnerService.Show("Loading Cards...");
    const api = ApiFactory.CreateDataClient();
    try {
      const result = await api.factFindLiabilityCard_IndexAll(this.contactId);
      this.cards = result || [];
      if (showLoader) LoadingSpinnerService.Hide();
    } catch (e) {
      this.cards = [];
      LoadingSpinnerService.Failure("Could not load Cards. Please try again.");
    }
  }

  private async rowSelected(item: FactFindLiabilityCardDto) {
    if (!(await this.checkForChanges())) {
      return;
    }

    this.formEnabled = true;
    this.mode = "update";
    this.displayModel = item;
    this.modelSig = JSON.stringify(this.displayModel.toJSON()).toString();
    if (this.displayModel.cardOwner) {
      this.$refs.owner.setSelected(this.displayModel.cardOwner);
    } else {
      this.$refs.owner.setSelected(ClientSelector.Main);
    }

    this.$refs.productProvider.setSelected(this.displayModel.cardCompany);
  }

  private saveClicked() {
    this.formEnabled = false;
    this.clearData();
    this.mode = "default";
  }

  private createClicked() {
    this.clearData();
    this.mode = "create";
    this.formEnabled = true;
  }

  private updateClicked() {
    this.mode = "update";
    this.formEnabled = true;
  }

  private clearData() {
    this.displayModel = this.emptyCard;
    this.displayModel.cardOwner = ClientSelector.Main;
    this.$refs.owner.setSelected(ClientSelector.Main);
    this.$refs.productProvider.setSelected(new ProductProviderDto());
  }

  public async checkForChanges(): Promise<boolean> {
    if (this.isDisplayModelEmpty() == false) {
      if (this.hasChanges() == true) {
        if (confirm("Would you like to save your changes?")) {
          return await this.saveChanges();
        }
      }
    }

    return true;
  }

  public async saveChanges(): Promise<boolean> {
    if (this.$refs.mainForm.checkValidity()) {
      if (this.mode === "update") {
        return await this.update();
      } else if (this.mode === "create") {
        return await this.createNew();
      }

      return true;
    }

    this.alertService.error(
      "Form Validation Failed",
      "Please complete all required fields"
    );
    return false;
  }

  private isDisplayModelEmpty(): boolean {
    return (
      this.mode !== "create" &&
      JSON.stringify(this.displayModel.toJSON()) ===
        JSON.stringify(this.emptyCard.toJSON())
    );
  }

  private hasChanges(): boolean {
    const s1 = JSON.stringify(this.displayModel.toJSON()).toString();
    if (s1 !== this.modelSig) {
      return true;
    } else {
      return false;
    }
  }

  private ownerSelected(owner: ClientSelector) {
    this.displayModel.cardOwner = owner;
  }
  private productProviderSelected(productProvider: ProductProviderDto) {
    this.displayModel.cardCompany = productProvider;
  }
}
